import React, { useEffect, useState } from "react"
import * as TrinityAPI from "../../../../requests/TrinityAPI"

interface IClientManager {
  id: number
  userId: number
  name: string
  username: string
  roles: string
}

export const ClientManagerPicker: React.FC<{
  label: string
  userId: number
}> = ({ label, userId }) => {
  const [users, setUsers] = useState<IClientManager[]>([])
  const [userList, setUserList] = useState<IClientManager[]>([])
  const [username, setUsername] = useState<string>()

  useEffect(() => {
    TrinityAPI.getClientManagers(userId, response => {
      if (response.status === 200) {
        setUsers(response.data)
      }
    })
  }, [userId])

  useEffect(() => {
    if (!username || username.length === 0) {
      setUserList([])
      return
    }
    TrinityAPI.suggestClientManagers(userId, username, response => {
      if (response.status === 200) setUserList(response.data)
    })
  }, [username])

  const pickUser = (user: IClientManager) => {
    if (users.filter(u => u.username === user.username).length > 0) return
    TrinityAPI.addClientManagers(userId, user.userId, response => {
      if (response.status === 200) {
        user.id = response.data
        const newUsers = [...users, user]
        setUsers(newUsers)
        setUsername("")
        setUserList([])
      }
    })
  }

  const removeUser = (id: number) => {
    const newUsers = users.filter(u => u.id !== id)
    TrinityAPI.removeClientManagers(userId, id, response => {
      if (response.status === 200) {
        setUsers(newUsers)
      }
    })
  }

  const getHumanRoles = (roles: string): string => {
    let humanRoles = []
    humanRoles.push(roles.includes("MANAGER_ORD") ? "Ордера" : "")
    humanRoles.push(roles.includes("MANAGER_REQ") ? "Заявки и пополнения" : "")
    humanRoles = humanRoles.filter(r => {
      if (r) return r

      return false
    })
    return humanRoles.length > 0 ? `(Роли: ${humanRoles.join(", ").trim()})` : ""
  }

  return (
    <fieldset>
      <legend>{label}</legend>
      <input
        type="text"
        className="input-form"
        placeholder="К примеру someuser@gmail.com"
        onChange={e => setUsername(e.target.value)}
        value={username}
      />
      <ul className="prompt-list">
        {userList.map((u, index) => (
          <li className="promp-item" key={index} onClick={() => pickUser(u)}>
            <>
              {u.username} {getHumanRoles(u.roles)}
            </>
          </li>
        ))}
      </ul>

      <ul className="tag-list">
        {users.map((user, index) => (
          <li className="tag-item" key={index}>
            {user.username}
            <span className="close-country" onClick={() => removeUser(user.id)} />
          </li>
        ))}
      </ul>
    </fieldset>
  )
}
